import { render, staticRenderFns } from "./onlineBank.vue?vue&type=template&id=277d653f&scoped=true"
import script from "./onlineBank.vue?vue&type=script&lang=js"
export * from "./onlineBank.vue?vue&type=script&lang=js"
import style0 from "./onlineBank.vue?vue&type=style&index=0&id=277d653f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d653f",
  null
  
)

export default component.exports